import React from "react";
import { motion } from "framer-motion";
import Slider from "./Slider";
import CountUp from "react-countup";
import ArtworkCard from "./ArtworkCard";
import restart from "./../images/icons/replay_black_24dp.svg";
import share from "./../images/icons/share_black_24dp.svg";

function EndPanel(props) {
  // Declare a new state variable, which we'll call "count"
  //const [count, setCount] = useState(0);

  return (
    <motion.div
      className="w-80 h-100 center custom-light "
      initial={{ x: "150%", opacity: 0 }}
      animate={{ x: "0%", opacity: 1 }}
      transition={{
        opacity: { duration: 0.8 },
        duration: 0.45,
        delay: 0.5,
        ease: "easeOut"
      }}
    >
      <h1 className="normal mt0 pt3">{props.i18n.game_over}</h1>
      <p className="f6 mt2 pb0 mb2">{props.i18n.well_done}</p>
      <p className="f6 mt2 pb0 mb2">{props.i18n.your_score_is}</p>
      <p className="f2 ma0 pa0 mb2">
        <CountUp delay={1} end={Math.round(props.totalScore)} duration={1} /> /
        500
      </p>
      <p className="f6 ma0 pa0 mb2">{props.i18n.points}</p>
      <Slider score={props.totalScore / props.numRounds} delay={1} />
      <button
        className="flex img-btn items-center justify-center mt3 mb3 bg-custom-light custom-dark"
        onClick={() => {
          props.resetGame(true);
        }}
      >
        <img src={restart} alt="Play again" />
        <p className="pa0 ma0">{props.i18n.start_again}</p>
      </button>
      <button
        className="flex img-btn items-center justify-center mt3 mb3 ml0 ml0-ns bg-custom-light custom-dark flex img-btn items-center justify-center"
        onClick={() => {
          props.share();
        }}
      >
        <img src={share} alt="Share" />
        <p className="pa0 ma0">{props.i18n.share_your_score}</p>
      </button>
      <p className="mt4 f4 mb4">{props.i18n.your_collection}</p>
      {Array.from({ length: props.numRounds }, (_, i) => (
        <ArtworkCard
          gameData={props.gameData}
          round={i}
          displayMoreInfo={props.displayMoreInfo}
          key={i}
        />
      ))}
    </motion.div>
  );
}

export default EndPanel;
